import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { ContractService } from 'src/app/services/contract.service';
import { GridService } from 'src/app/services/grid.service';
import { UtilityService } from 'src/app/services/utility.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-contracts-grid',
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    '../base-grid/base-grid.component.less',
    './contracts-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ContractsGridComponent extends BaseGridComponent {
  constructor(
    private ContractService: ContractService,
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'Contract';
    this.rowModelType = 'serverSide';

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.ContractService.getContracts(queryObject),
          this.ContractService.getContractCount(countQueryObject)
        ]).subscribe({
          next: ([Contracts, contractCount]) => {
            const successObject: {
              rowData: any[];
              rowCount: number;
            } = {
              rowData: Contracts,
              rowCount: contractCount
            };

            params.success(successObject);
          },
          error: (err) => {
            console.log(err);
            params.fail();
          }
        });
      }
    };
  }
}
